// <variant-selects> is swapped for freshly rendered HTML on every option change,
// so anything held in the DOM is lost. Keep the chosen colour here instead.
const tshirtColorChoices = new Map();

if (!customElements.get('tshirt-color-picker')) {
  customElements.define(
    'tshirt-color-picker',
    class TshirtColorPicker extends HTMLElement {
      connectedCallback() {
        const saved = tshirtColorChoices.get(this.dataset.key);
        const match = this.querySelector(`input[type="radio"][value="${CSS.escape(saved || '')}"]`);
        if (match) match.checked = true;

        if (this.bound) return;
        this.bound = true;

        this.addEventListener('change', (event) => {
          // variant-selects treats any change inside it as an option change and
          // refetches. A colour is a line item property, not an option.
          event.stopPropagation();
          tshirtColorChoices.set(this.dataset.key, event.target.value);
        });
      }
    }
  );
}

// When the material changes, move the size to the first one that exists for the
// new material (in stock if possible) before variant-selects reads the selection
// and refetches. Without this Shopify is asked for a combination that doesn't
// exist, such as T-Shirt / Infant, and falls back to a variant of its own choosing.
// Runs in the capture phase so it lands before variant-selects' own listener.
if (!window.tshirtMaterialListener) {
  window.tshirtMaterialListener = true;

  document.addEventListener(
    'change',
    (event) => {
      const material = event.target.closest?.('.variant-material-form__container input[type="radio"]');
      if (!material) return;

      const key = `|${material.value}|`;
      const sizes = Array.from(
        material.closest('variant-selects').querySelectorAll('input[data-materials]')
      ).filter((size) => size.dataset.materials.includes(key));

      const next = sizes.find((size) => size.dataset.inStock.includes(key)) || sizes[0];
      if (next) next.checked = true;

      // Shopify re-renders the variant picker, price and media on an option change,
      // but not the description blocks — swap them here.
      material.closest('product-info')?.classList.toggle('tshirt-selected', /shirt/i.test(material.value));
    },
    true
  );
}
